import script from "./CommonTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonTitle.vue?vue&type=script&setup=true&lang=js"

import "./CommonTitle.vue?vue&type=style&index=0&id=73b3cb09&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73b3cb09"]])

export default __exports__